import { observable, runInAction } from 'mobx';
import { IOperator, IRegion } from 'src/Interfaces/WellInterface';
import { API } from 'src/Services/Api/Api';
import { ICategory, IContractor, IGroupEmail, IOperatorRegionExpensePrice, IOperatorRegionPrice, IOptionFieldList, IRegionExpensePrice, IRegionProductPrice, IRole, ISolidsControlEquip, ITaxRate, IUnitOfMeasure, IWarehouse, IWellList, Role } from '../../Interfaces/AdminInterface';
import { IEBPExpenseType, IProduct } from '../../Interfaces/TestInterface';
import { IUser, IUserRole } from '../../Interfaces/UserInterface';
import DataService from '../../Services/Data';
import { RootStore } from '../Root/RootStore';
import { ApprovalApi } from '../Tests/ApprovalApi';



class AdminAPI {
    private api: API;
    constructor(Api: API) {
        this.api = Api;
    }
    /**
     * 
     * Users APIs start here
     * 
     */
        public async getUsers() {
            try {
                const data = await this.api.get('/Account/users');
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async getUser(userName: string) {
            try {
                const data = await this.api.get('/Account/' + userName);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async getUserRoles() {
            try {
                const data = await this.api.get('/Account/roles');
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async putUser(user: IUser) {
            try {
                const data = await this.api.put('/Account/user', user);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async postUser(user: IUser) {
            try {
                const data = await this.api.post('/Account/register', user);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async deleteUser(user: IUser) {
            try {
                const data = await this.api.delete('/Account/' + user.email);
                return data;
            }
            catch (error) {
                throw error;
            }
        }
    /* ** */

    /**
     * 
     * Category APIs start here
     * 
     */
        public async getCategories(id?: any) {
            let url = '/Categorys';

            if ( id ) {
                url += '/' + id;
            }
            try {
                const data = await this.api.get(url);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async saveCategories(category: ICategory) {
            let url = '/Categorys';

            if ( category.id ) {
                url += '/' + category.id;
            }

            try {
                let data;
                if ( category.id ) {
                    data = await this.api.put(url, category); 
                } else {
                    data = await this.api.post(url, category);
                }
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async archiveCategory(category: ICategory) {
            try {
                const data = await this.api.delete('/Categorys/' + category.id + '/archive');
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async deleteCategory(category: ICategory) {
            try {
                const data = await this.api.delete('/Categorys/' + category.id);
                return data;
            }
            catch (error) {
                throw error;
            }
        }
    /* ** */

    /**
     * 
     * Operator APIs start here
     * 
     */
        public async getOperators(id?: any) {
            let url = '/Operators';

            if ( id ) {
                url += '/' + id;
            }
            try {
                const data = await this.api.get(url);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async saveOperators(operator: IOperator) {
            let url = '/Operators';

            if ( operator.id ) {
                url += '/' + operator.id;
            }

            try {
                let data;
                if ( operator.id ) {
                    data = await this.api.put(url, operator); 
                } else {
                    data = await this.api.post(url, operator);
                }
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async deleteOperator(operator: IOperator) {
            try {
                const data = await this.api.delete('/Operators/' + operator.id);
                return data;
            }
            catch (error) {
                throw error;
            }
        }
    

        public async archiveOperator(operator: IOperator) {
            try {
                const data = await this.api.delete('/Operators/' + operator.id + '/archive');
                return data;
            }
            catch (error) {
                console.log('hit');
                throw error;
            }
        }


    public async getOperatorPrices(operatorId: string, regionId: string) {
        let url = '';
        if (regionId && regionId !== '') {
            url = `/Operators/${operatorId}/products/${regionId}`;
        } else {
            url = '/Operators/' + operatorId + '/products';

        }
        try {
            const data = await this.api.get(url);
            return data;
        }
        catch (error) {
            throw error;
        }
    }

    public async getWellList(operatorId: string, regionId: string) {
        return await this.api.get(`/Operators/${operatorId}/wells/${regionId}`);
    }
    
    public async getOperatorExpensePrices(operatorId: string, regionId: string) {
        return await this.api.get(`/Operators/${operatorId}/expenses/${regionId}`);
    }

    public async postNewExpenseList(operatorId: string, regionId: string, expenses: IOperatorRegionExpensePrice[]) {
        return await this.api.post(`/Operators/${operatorId}/expenses/${regionId}`, expenses);
    }

    public async postNewProductList(operatorId: string, regionId: string, products: IOperatorRegionPrice[]){
      const data = await this.api.post(`/Operators/${operatorId}/products/${regionId}`, products);
      return data;
    }

    // public async postOperatorPrices (operatorId: string, regionId: string, operatorPrices: IOperatorRegionPrice[]) {
    //     const data = await this.api.post(`/Operators/${operatorId}/expenses/${regionId}`, operatorPrices);
    //     return data;
    // }

    public async updateWellProductList(operatorId: string, regionId: string, well: IWellList) {
        const data = await this.api.post(`/Operators/${operatorId}/well/${regionId}`, well);
        return data;
    }

    // public async postOperatorPrices(operatorId: string, operatorPrices: IOperatorRegionPrice[], regionId?: string) {
    //     console.log(operatorPrices);
    //     let url = '';
    //     if (regionId && regionId !== '') {
    //         url = `/Operators/${operatorId}/products/${regionId}`;
    //     } else {
    //         url = '/Operators/' + operatorId + '/products';

    //     }
    //     try {
    //         const data = await this.api.put(url, operatorPrices);
    //         return data;
    //     }
    //     catch (error) {
    //         throw error;
    //     }
    // }

    /* *
        Region APIs
    * */

    public async getRegions() {
        return await this.api.get('/regions');
    }

    public async getRegion(regionId: string) {
        return await this.api.get(`/regions/${regionId}`);
    }

    public async postRegion(region: IRegion) {
        const data = await this.api.post(`/regions`, region);
        return data;
    }

    public async putRegion(region: IRegion) {
        const data = await this.api.put(`/regions/${region.id}`, region);
        return data;
    }

    public async deleteRegion(regionId: string) {
        const data = await this.api.delete(`/regions/${regionId}`);
        return data;
    }

    /**
     * 
     * Region Product APIs
     */

     public getRegionProducts(regionId: string): Promise<IRegionProductPrice[]> {
         return this.api.get(`/regions/${regionId}/products`);
     }

     public postRegionProducts(regionId: string, regionPrices: IRegionProductPrice[]) {
         return this.api.post(`/regions/${regionId}/products`, regionPrices);
     }

     public getRegionExpenses(regionId: string): Promise<IRegionExpensePrice[]> {
         return this.api.get(`/regions/${regionId}/expenses`);
     }

     public async postRegionExpenses(regionId: string, regionExpensePrices: IRegionExpensePrice[]) {
         return this.api.post(`/regions/${regionId}/expenses`, regionExpensePrices);
     }

    /**
     *
     * Unit Of Measure APIs start here
     *
     */
     public async getUnitOfMeasure() {
         return await this.api.get('/UnitOfMeasure');
     }

     public async getSingleUnitOfMeasure(unitOfMeasureId: string) {
         return await this.api.get(`/UnitOfMeasure/${unitOfMeasureId}`);
     }

     public async saveUnitOfMeasure(unitOfMeasure: IUnitOfMeasure) {
         const data = await this.api.post(`/UnitOfMeasure`, unitOfMeasure);
         return data;
     }

     public async putUnitOfMeasure(unitOfMeasure: IUnitOfMeasure) {
         const data = await this.api.put(`/UnitOfMeasure/${unitOfMeasure.id}`, unitOfMeasure);
         return data;
     }

     public async deleteUnitOfMeasure (unitOfMeasureId: string) {
        return this.api.delete(`/UnitOfMeasure/${unitOfMeasureId}`);
     }

     public getUnitSizes(unitOfMeasure?: string) {
        const append: string = (unitOfMeasure) ? '/' + unitOfMeasure : '';
         return this.api.get(`/${unitOfMeasure}/UnitSize` + append)
            .then(
                (data: any) => data,
                (error: any) => {throw error;}
            );
     }

    /* ** */
    /**
     * 
     * Contractor APIs start here
     * 
     */
        public async getContractors(id?: any) {
            let url = '/Contractors';

            if ( id ) {
                url += '/' + id;
            }
            try {
                const data = await this.api.get(url);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async saveContractors(contractor: IContractor) {
            let url = '/Contractors';

            if ( contractor.id ) {
                url += '/' + contractor.id;
            }

            try {
                let data;
                if ( contractor.id ) {
                    data = await this.api.put(url, contractor); 
                } else {
                    data = await this.api.post(url, contractor);
                }
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async deleteContractor(contractor: IContractor) {
            try {
                const data = await this.api.delete('/Contractors/' + contractor.id);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async archiveContractor(contractor: IContractor) {
            try {
                const data = await this.api.delete('/Contractors/' + contractor.id + '/archive');
                return data;
            }
            catch (error) {
                throw error;
            }
        }
    /* ** */

    /**
     * 
     * ExpenseType APIs start here
     * 
     */
        public async getExpenseTypes(id?: any) {
            let url = '/ExpenseTypes';

            if ( id ) {
                url += '/' + id;
            }
            try {
                const data = await this.api.get(url);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async saveExpenseTypes(expenseType: IEBPExpenseType) {
            let url = '/ExpenseTypes';

            if ( expenseType.id ) {
                url += '/' + expenseType.id;
            }

            try {
                let data;
                if ( expenseType.id ) {
                    data = await this.api.put(url, expenseType); 
                } else {
                    data = await this.api.post(url, expenseType);
                }
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async deleteExpenseType(expenseType: IEBPExpenseType) {
            try {
                const data = await this.api.delete('/ExpenseTypes/' + expenseType.id);
                return data;
            }
            catch (error) {
                throw error;
            }
        }
    /* ** */


    /**
     * 
     * SolidsControlEquip APIs start here
     * 
     */
        public async getSolidsControlEquip(id?: any) {
            let url = '/SolidsControlEquip';

            if ( id ) {
                url += '/' + id;
            }
            try {
                const data = await this.api.get(url);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async saveSolidsControlEquip(solidControlEquip: ISolidsControlEquip) {
            let url = '/SolidsControlEquip';

            if ( solidControlEquip.id ) {
                url += '/' + solidControlEquip.id;
            }

            try {
                let data;
                if ( solidControlEquip.id ) {
                    data = await this.api.put(url, solidControlEquip); 
                } else {
                    data = await this.api.post(url, solidControlEquip);
                }
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async deleteSolidsControlEquip(solidControlEquip: ISolidsControlEquip) {
            try {
                const data = await this.api.delete('/SolidsControlEquip/' + solidControlEquip.id);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async archiveSolidsControlEquip(solidControlEquip: ISolidsControlEquip) {
            try {
                const data = await this.api.put('/SolidsControlEquip/' + solidControlEquip.id + '/archive', solidControlEquip);
                return data;
            }
            catch (error) {
                throw error;
            }
        }
    /* ** */

    /**
     * 
     * Warehouse APIs start here
     *
     */
        public async getWarehouses(id?: any) {
            let url = '/Warehouses';

            if ( id ) {
                url += '/' + id;
            }
            try {
                const data = await this.api.get(url);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async saveWarehouses(warehouse: IWarehouse) {
            let url = '/Warehouses';

            if ( warehouse.id ) {
                url += '/' + warehouse.id;
            }

            try {
                let data;
                if ( warehouse.id ) {
                    data = await this.api.put(url, warehouse); 
                } else {
                    data = await this.api.post(url, warehouse);
                }
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async deleteWarehouse(warehouse: IWarehouse) {
            try {
                const data = await this.api.delete('/Warehouses/' + warehouse.id);
                return data;
            }
            catch (error) {
                throw error;
            }
        }
    /* ** */

    /**
     * 
     * Products APIs start here
     * 
     */
        public async getProducts(id?: any) {
            let url = '/Products';

            if ( id ) {
                url += '/' + id;
            }

            try {
                const data = await this.api.get(url);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async saveProduct(product: IProduct) {
            let url = '/Products';

            if ( product.id ) {
                url += '/' + product.id;
            }

            try {
                let data;
                if ( product.id ) {
                    data = await this.api.put(url, product); 
                } else {
                    data = await this.api.post(url, product);
                }
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async deleteProduct(product: IProduct) {
            try {
                const data = await this.api.delete('/Products/' + product.id);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public getTenantTaxRates(): Promise<ITaxRate[]> {
            return this.api.get('/products/taxrate');
        }

        public postTenantTaxRates(taxRates: ITaxRate[]) {
            return this.api.post('/products/taxrate', taxRates);
        }
    /* ** */

    /**
     * 
     * Field List APIs start here
     * 
     */
        public async getFieldLists(id?: any) {
            let url = '/OptionalFieldLists';

            if ( id ) {
                url += '/' + id;
            }

            try {
                const data = await this.api.get(url);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async saveFieldLists(fieldList: IOptionFieldList) {
            const url = '/OptionalFieldLists/';

            try {
                const data = await this.api.put(url, fieldList);
                return data;
            }
            catch (error) {
                throw error;
            }
        }

        public async deleteFieldList(fieldList: IOptionFieldList) {
            try {
                const data = await this.api.delete('/OptionalFieldLists/' + fieldList.id);
                return data;
            }
            catch (error) {
                throw error;
            }
        }
    /* ** */

    /**
     *
     * UnitOfMeasure APIs start here
     *
     */


    /* ** */

        public async getAllPermissions(): Promise<string[]> {
            return this.api.get('/Account/permissions');
        }

        public async getAllRoles(): Promise<IRole[]> {
            return this.api.get('/Account/roles');
        }

        public async getRoleById(roleId: string) {
            return this.api.get('/Account/roles/' + roleId);
        }
        public async postRole(role: IRole) {
            return this.api.post('/Account/roles', role);
        }

        public async putRole(role: IRole) {
            return this.api.put('/Account/roles/' + role.id, role);
        }

        public async archiveRole(role: IRole) {
            return this.api.put('/Account/roles/' + role.id + '/archive', role);
        }
    
        public getTenantGroupEmails() {
            return this.api.get('/Tenant/groupemails');
        }

        public postTenantGroupEmails(groupEmails: IGroupEmail[]) {
            return this.api.post('/Tenant/groupemails', groupEmails);
        }

}

export class AdminStore {
    @observable public usersList: IUser[] = [];
    @observable public userDetails: IUser = new IUser();
    @observable public categories: ICategory[] = [];
    @observable public category: ICategory = new ICategory();
    @observable public expenseTypes: IEBPExpenseType[] = [];
    @observable public expenseType: IEBPExpenseType = new IEBPExpenseType();
    @observable public operators: IOperator[] = [];
    @observable public operator: IOperator = new IOperator();
    @observable public operatorProductPrices: IOperatorRegionPrice[];
    @observable public wellList: IWellList[];
    @observable public operatorExpensePrices: IOperatorRegionExpensePrice[];
    @observable public regionProductPrices: IRegionProductPrice[];
    @observable public regionExpensePrices: IRegionExpensePrice[];
    @observable public products: IProduct[] = [];
    @observable public product: IProduct = new IProduct();
    @observable public contractors: IContractor[] = [];
    @observable public contractor: IContractor = new IContractor();
    @observable public warehouses: IWarehouse[] = [];
    @observable public warehouse: IWarehouse = new IWarehouse();
    @observable public solidsControlEquips: ISolidsControlEquip[] = [];
    @observable public solidsControlEquip: ISolidsControlEquip = new ISolidsControlEquip();
    @observable public userRoles: IUserRole[] = [];
    @observable public fieldLists: any[] = [];
    @observable public fieldList: any = {};
    @observable public unitOfMeasures: IUnitOfMeasure[] = [];
    @observable public unitOfMeasure: IUnitOfMeasure = new IUnitOfMeasure();
    @observable public unitSizes: any[];


    /**
     * Observables for permissions based access
     */
    @observable public permissions: string[] = [] as string[];
    @observable public roles: IRole[] = [] as IRole[];
    @observable public role: IRole = new Role();

    public dataService: any = new DataService();
    private approvalApi: ApprovalApi;
    private adminAPI: AdminAPI;
    private RootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.RootStore = rootStore;
        this.adminAPI = new AdminAPI(this.RootStore.Api);
        this.approvalApi = new ApprovalApi(this.RootStore.Api);
    }
    

    /**
     * 
     * User Methods
     */
    public getUsers = async() => {
        const list: any[] = await this.adminAPI.getUsers();

        runInAction(() => {
            const sorted = this.dataService.sort(list, {'firstName': 'asc', 'lastName': 'asc'});
            this.usersList = sorted;
        });
    }

    public getUserRoles = async() => {
        const list: IUserRole[] = await this.adminAPI.getUserRoles();

        runInAction(() => {
            const sorted = this.dataService.sort(list, {'name': 'asc'});
            this.userRoles = sorted;
        });
    }

    public getUserDetails = async (userName: string) => {
        const userDetails: any = await this.adminAPI.getUser(userName);

        runInAction(() => {
            this.userDetails = userDetails;
        });
    }

    public putUser = async (user: IUser) => {
        return this.adminAPI.putUser(user);
    }

    public postUser = async (user: IUser) => {
        return this.adminAPI.postUser(user);
    }

    public deleteUser = async (user: IUser) => {
        return this.adminAPI.deleteUser(user);
    }
    /* ** */

    /**
     * 
     * Category Methods
     * 
     */
    public getCategory = async (id?: any) => {
        const category: ICategory = await this.adminAPI.getCategories(id);

        runInAction(() => {
            this.category = category;
        });
    }

    public getCategories = async (id?: any) => {
        const categories: ICategory[] = await this.adminAPI.getCategories(id);

        runInAction(() => {
            const sorted = this.dataService.sort(categories, {'name': 'asc'});
            this.categories = sorted;
        });
    }

    public saveCategory = async (category: ICategory) => {
        return this.adminAPI.saveCategories(category);
    }

    public archiveCategory = async (category: ICategory) => {
        return this.adminAPI.archiveCategory(category);
    }

    public deleteCategory = async (category: ICategory) => {
        return this.adminAPI.deleteCategory(category);
    }
    /* ** */

    /**
     * 
     * Operator Methods
     * 
     */
    public getOperator = async (id?: any) => {
        const operator: IOperator = await this.adminAPI.getOperators(id);

        runInAction(() => {
            this.operator = operator;
        });
        return operator;
    }

    public getOperatorPrices = async(operatorId: string, regionId: string) => {
        const operatorPrices = await this.adminAPI.getOperatorPrices(operatorId, regionId);
        runInAction(() => {
            this.operatorProductPrices = operatorPrices;
        });
        return operatorPrices;
    }

    public getWellList = async(operatorId: string, regionId: string) => {
        const wells = await this.adminAPI.getWellList(operatorId, regionId);
    
        runInAction(() => {
            this.wellList = wells;
      
        });
    }

    public getOperatorExpenses = async(operatorId: string, regionId: string) => {
        const operatorPrices = await this.adminAPI.getOperatorExpensePrices(operatorId, regionId);
        runInAction(() => {
            this.operatorExpensePrices = operatorPrices;
          //  console.log(operatorPrices);
        });
    }

    // public postNewPriceList =  async(operatorId: string, regionId: string, dates: IOperatorRegionPrice) => {
    //   const result = await this.adminAPI.postNewPriceList(operatorId, regionId, dates);
    //     if (result && result.length && result.length > 0) {
    //         runInAction(() => {
                
    //         });
    //     } else {
    //         throw new Error("Error in Price Product List");
    //     }
    //     return result;
    // }

    // public postNewExpenseList = async(operatorId: string, regionId: string, dates: IOperatorRegionPrice) => {
    //     const result = await this.adminAPI.postNewExpenseList(operatorId, regionId, dates);
    //     if (result && result.length && result.length > 0) {
    //         runInAction(() => {
             
    //         });
    //     } else {
    //         throw new Error("Error in Price List");
    //     }
    //     return result;
    // }
    public postNewProductList = async (operatorId: string, regionId: string, products: IOperatorRegionPrice[]) => {
        const result = await this.adminAPI.postNewProductList(operatorId, regionId, products);
        return result;
    }

    public postNewExpenseList = async (operatorId: string, regionId: string, expenses: IOperatorRegionExpensePrice[]) => {
        const result = await this.adminAPI.postNewExpenseList(operatorId, regionId, expenses);
        return result;
    }

    public updateWellProductList = (operatorId: string, regionId: string, well: IWellList) => {
        return this.adminAPI.updateWellProductList(operatorId, regionId, well);
        
    }

    // public postOperatorPrices = async(operatorId: string, operatorPrices: IOperatorRegionPrice[], regionId: string) => {
    //     const result = await this.adminAPI.postOperatorPrices(operatorId, operatorPrices, regionId);
    //     if (result && result.length && result.length > 0) {
    //         runInAction(() => {
    //             this.operatorProductPrices = operatorPrices;   
    //         });
    //     } 
    //     // else {
    //     //     throw new Error("Error in Price Product List");
    //     // }
    //     return result;
    // } 

    // public postOperatorExpensePrices = async(operatorId: string, operatorPrices: IOperatorRegionExpensePrice[], regionId: string) => {
    //     const result = await this.adminAPI.postOperatorExpensePrices(operatorId, regionId, operatorPrices);
    //     if (result && result.length && result.length > 0) {
    //         runInAction(() => {
    //             this.operatorExpensePrices = operatorPrices;
    //         });
    //     } else {
    //         // throw new Error("Error in Price List");
    //     }
    //     return result;
    // } 

    public getOperators = async (id?: any) => {
        const operators: IOperator[] = await this.adminAPI.getOperators(id);

        runInAction(() => {
            this.operators = operators;
        });
    }

    public saveOperator = async (operator: IOperator) => {
        return this.adminAPI.saveOperators(operator);
    }

    public deleteOperator = async (operator: IOperator) => {
        return this.adminAPI.deleteOperator(operator);
    }

    public archiveOperator= async (operator: IOperator) => {
        return this.adminAPI.archiveOperator(operator);
    }
    
    /**
     * Region Methods
     */
    public getRegions = () => {
        return this.adminAPI.getRegions();
    }

    public getRegion = (regionId: string) => {
        return this.adminAPI.getRegion(regionId);
    }
    public postRegion = (region: IRegion) => {
        return this.adminAPI.postRegion(region);
    }

    public putRegion = (region: IRegion) => {
        return this.adminAPI.putRegion(region);
    }

    public deleteRegion = (regionId: string) => {
        return this.adminAPI.deleteRegion(regionId);
    }

    public getRegionProducts = async (regionId: string) => {
        const prices = await this.adminAPI.getRegionProducts(regionId);
        runInAction(() => {
            this.regionProductPrices = prices;
        });
        return prices;
    }

    public getRegionExpenses = async (regionId: string) => {
        const prices = await this.adminAPI.getRegionExpenses(regionId);
        runInAction(() => {
            this.regionExpensePrices = prices;
        });
        return prices;
    }
    public postRegionProducts = (regionId: string, regionProducts: IRegionProductPrice[]) => {
        return this.adminAPI.postRegionProducts(regionId, regionProducts);
    }

    public postRegionExpenses = (regionId: string, regionExpenses: IRegionExpensePrice[]) => {
        return this.adminAPI.postRegionExpenses(regionId, regionExpenses);
    }
    /* ** */

    /**
     * 
     * Product Methods
     * 
     */
    public getProducts = async (id?: any) => {
        const products: IProduct[] = await this.adminAPI.getProducts(id);
        const sorted: IProduct[] = this.dataService.sort(products, {'name': 'asc'});

        runInAction(() => {
            this.products = sorted;
        });
        return sorted;
    }
  
    public getProduct = async (id?: any) => {
        const product: IProduct = await this.adminAPI.getProducts(id);

        runInAction(() => {
            this.product = product;
        });
    }

    public saveProduct = async (product: IProduct) => {
        return this.adminAPI.saveProduct(product);
    }

    public deleteProduct = async (product: IProduct) => {
        return this.adminAPI.deleteProduct(product);
    }

    public getAllProductsForApproval = () => {
        return this.approvalApi.getProductsForApproval();
    }

    public approveProduct = (productId: string) => {
        return this.approvalApi.approveProduct(productId);
    }

    public rejectProduct = (productId: string) => {
        return this.approvalApi.rejectProduct(productId);
    }
    /* ** */

    /**
     * 
     * Contractor
     * 
     */
    public getContractor = async (id?: any) => {
        const contractor: IContractor = await this.adminAPI.getContractors(id);

        runInAction(() => {
            this.contractor = contractor;
        });
    }

    public getContractors = async (id?: any) => {
        const contractors: IContractor[] = await this.adminAPI.getContractors(id);

        runInAction(() => {
            this.contractors = contractors;
        });
    }

    public saveContractor = async (contractor: IContractor) => {
        return this.adminAPI.saveContractors(contractor);
    }

    public deleteContractor = async (contractor: IContractor) => {
        return this.adminAPI.deleteContractor(contractor);
    }


    public archiveContractor = async (contractor: IContractor) => {
        return this.adminAPI.archiveContractor(contractor);
    }
    /* ** */

    /**
     * 
     * Expense Type Method
     * 
     */
    public getExpenseType = async (id?: any) => {
        const expenseType: IEBPExpenseType = await this.adminAPI.getExpenseTypes(id);

        runInAction(() => {
            this.expenseType = expenseType;
        });
    }

    public getExpenseTypes = async (id?: any) => {
        const expenseTypes: IEBPExpenseType[] = await this.adminAPI.getExpenseTypes(id);

        runInAction(() => {
            this.expenseTypes = expenseTypes;
        });
        return expenseTypes;
    }

    public saveExpenseType = async (expenseType: any) => {
        return this.adminAPI.saveExpenseTypes(expenseType);
    }

    public deleteExpenseType = async (expenseType: IEBPExpenseType) => {
        return this.adminAPI.deleteExpenseType(expenseType);
    }
    /* ** */
    
    /** 
     * 
     * Unit Of Measure Method
     * 
     */ 
    public getUnitOfMeasures = async ()=> {
        const data: IUnitOfMeasure[] = await this.adminAPI.getUnitOfMeasure();
        runInAction(() => {
            this.unitOfMeasures = data;
        });
        return data;
    }

    public getSingleUnitOfMeasure = async(unitOfMeasureId: string) => {
        const data = await this.adminAPI.getSingleUnitOfMeasure(unitOfMeasureId);
        runInAction(() => {
            this.unitOfMeasure = data;
        });
        return data;
    }

    public saveUnitOfMeasure = (unitOfMeasure: IUnitOfMeasure) => {
        return this.adminAPI.saveUnitOfMeasure(unitOfMeasure);
    }

    public putUnitOfMeasure = (unitOfMeasure: IUnitOfMeasure) => {
        return this.adminAPI.putUnitOfMeasure(unitOfMeasure);
    }

    public deleteUnitOfMeasure = (unitOfMeasureId: string ) => {
        return this.adminAPI.deleteUnitOfMeasure(unitOfMeasureId);
    }

    public getUnitSizes = async (unitOfMeasure?: string) => {
        const list: any[] = await this.adminAPI.getUnitSizes(unitOfMeasure);

        runInAction(() => {
            this.unitSizes = list;
        });

    }

    /* ** */
    /**
     * 
     * Solids Control Equipment
     * 
     */
    public getSolidsControlEquip = async (id?: any) => {
        const solidsControlEquip: ISolidsControlEquip = await this.adminAPI.getSolidsControlEquip(id);

        runInAction(() => {
            this.solidsControlEquip = solidsControlEquip;
        });
    }

    public getSolidsControlEquips = async (id?: any) => {
        const solidsControlEquips: ISolidsControlEquip[] = await this.adminAPI.getSolidsControlEquip(id);

        runInAction(() => {
            this.solidsControlEquips = solidsControlEquips;
        });
    }

    public saveSolidsControlEquip = async (solidsControlEquip: any) => {
        return this.adminAPI.saveSolidsControlEquip(solidsControlEquip);
    }

    public deleteSolidsControlEquip = async (solidControlEquip: ISolidsControlEquip) => {
        return this.adminAPI.deleteSolidsControlEquip(solidControlEquip);
    }

    public archiveSolidsControlEquip = async (solidControlEquip: ISolidsControlEquip) => {
        return this.adminAPI.archiveSolidsControlEquip(solidControlEquip);
    }
    /* ** */

    /**
     * 
     * Warehouse Methods
     * 
     */
    public getWarehouse = async (id?: any) => {
        const warehouse: IWarehouse = await this.adminAPI.getWarehouses(id);

        runInAction(() => {
            this.warehouse = warehouse;
        });
    }

    public getWarehouses = async (id?: any) => {
        const warehouses: IWarehouse[] = await this.adminAPI.getWarehouses(id);

        runInAction(() => {
            this.warehouses = warehouses;
        });
    }

    public saveWarehouse = async (warehouse: any) => {
        return this.adminAPI.saveWarehouses(warehouse);
    }

    public deleteWarehouse = async (warehouse: IWarehouse) => {
        return this.adminAPI.deleteWarehouse(warehouse);
    }
    /* ** */

    /**
     * 
     * Field Lists
     * 
     */
    public getFieldLists = async (id?: any) => {
        const data: IOptionFieldList[] = await this.adminAPI.getFieldLists(id);

        runInAction(() => {
            if ( !id ) {
                this.fieldLists = data;
            } else {
                this.fieldList = data;
            }
        });
    }

    public saveFieldList = async (warehouse: any) => {
        return this.adminAPI.saveFieldLists(warehouse);
    }

    public deleteFieldList = async (fieldList: IOptionFieldList) => {
        return this.adminAPI.deleteFieldList(fieldList);
    }
    /* ** */


    /**
     * Roles and Permissions
     */

    public getAllPermissions = async (): Promise<string[]> => {
        const permissions = await this.adminAPI.getAllPermissions();
        runInAction(() => {
            this.permissions = permissions;
        });
        return permissions;
    }

    public getRoles = async () : Promise<IRole[]> => {
        const roles = await this.adminAPI.getAllRoles();
        runInAction(() => {
            this.roles = roles;
        });
        return roles;
    }

    public createNewRole = () => {
        const role = new Role();
        runInAction(() => {
            this.role = role;
        });
        return role;
    }

    public getRoleById = async (roleId: string): Promise<IRole> => {
        const role = await this.adminAPI.getRoleById(roleId);
        runInAction(() => {
            this.role = role;
        });
        return role;
    }

    public archiveRole = async (role: IRole) => {
        return this.adminAPI.archiveRole(role);
    }

    public saveRole = async (role: IRole) => {
        let result;
        if (role.id === '') {
            result = await this.adminAPI.postRole(role);
            role.id = result;
        } else {
            result = await this.adminAPI.putRole(role);
        }
        runInAction(() => {
            this.role = role;
        });
        return result;
    }

    public getTenantGroupEmails = ():Promise<IGroupEmail[]> => {
        return this.adminAPI.getTenantGroupEmails();
    }

    public postTenantGroupEmails = (groupEmails: IGroupEmail[]):Promise<string[]> => {
        return this.adminAPI.postTenantGroupEmails(groupEmails);
    }

    public getTaxRates = () => {
        return this.adminAPI.getTenantTaxRates();
    }

    public postTaxRates = (taxRates: ITaxRate[]) => {
        return this.adminAPI.postTenantTaxRates(taxRates);
    }

}


// WEBPACK FOOTER //
// ./src/Stores/Admin/AdminStore.tsx